import React from "react";
import PdfViewer from "../../PdfViewer";

const MantenimientoPreventivo = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/ingenieria-mantenimiento-preventivo-total.pdf`;
  /*const pdfUrl = "/pdf/ingenieria-mantenimiento-preventivo-total.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Mantenimiento Preventivo</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default MantenimientoPreventivo;
